import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import axios from "axios";
import { GoPlusCircle } from "react-icons/go";
import { trackPromise } from "react-promise-tracker";
import "./styles.scss";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { LuFolderOpen } from "react-icons/lu";

import { saveAs } from "file-saver";
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  message,
  Spin,
  Radio,
  notification,
} from "antd";

import {
  listarPastasPorFiltro,
  criarPasta,
  listarPastas,
  detalhesPasta,
  listarPastaFilha,
  inativarPasta,
  inativarPastas,
  obterPastasArquivosFilhos,
  listarPastasArquivosInativos,
  ativarPasta,
  moverPastaArquivoDragInDrop,
  listarPastasArquivos,
  alterarClassificacaoPasta,
  esvaziarLixeira,
} from "../../services/http/pastaService";

import {
  compartilharPasta,
  removerCompartilhamento,
  sairDoCompartilhametno,
  listarPastasCompartilhadasComigo,
  listarPastasCompartilhadasPorMim,
} from "../../services/http/pastaCompartilhada";

import {
  inativarArquivo,
  inativarArquivos,
  ativarArquivo,
  alterarClassificacaoArquivo,
} from "../../services/http/arquivoServico";

import {
  favoritarDocumento,
  listarFavoritos,
  removerFavorito,
} from "../../services/http/favoritoService";

import { listarPermissoes } from "../../services/http/usuariosService";

import {
  gerarLinkUnico,
  gerenciarLink,
  removerLink,
  obterLinks,
  gerarLinkMultiplo,
} from "../../services/http/linkCompartilhado";

import {
  registrarDownloadArquivo,
  registrarDownloadPasta,
  registrarVisualizacaoArquivo,
  registrarVisualizacaoPasta,
} from "../../services/http/dashboardService";
import { historicoPastaAberta } from "../../services/http/pastaService";
import { listarAtividadesRecentes } from "../../services/http/atividadeRecenteService";

import services from "../../services";

import MenuGaleriaMidia from "../../components/MenuGaleriaMidia";

import ListagemPastasArquivos from "../../components/ListagemPastasArquivos";
import ListagemLixeira from "../../components/ListagemLixeira";
import ListagemPastasCompartilhadas from "../../components/ListagemPastasCompartilhadas";
import ListagemItensRecentes from "../../components/ListagemItensRecentes";
import CardGaleria from "../../components/CardGaleria";
import Header from "../../components/Header";

import ModalUpload from "../../components/ModalUpload";
import ModalInfo from "../../components/ModalInfo";
import ModalRenomear from "../../components/ModalRenomear";
import ModalEditarPasta from "../../components/ModalEditarPasta";
import ModalEditarArquivo from "../../components/ModalEditarArquivo";
import ModalGerarLinkUnico from "../../components/ModalGerarLinkUnico";
import ModalGerarLinkMultiplos from "../../components/ModalGerarLinksMultiplos";
import ModalVisualizar from "../../components/ModalVisualizar";
import ModalCompartilharPasta from "../../components/ModalCompartilharPasta";
import ModalPastaCompartilhar from "../../components/ModalPastaCompartilhar";
import ModalPastaCopiar from "../../components/ModalPastaCopiar";
import ModalMoverPasta from "../../components/ModalMoverPasta";

import addPastaSvg from "../../assets/icons/addpasta.svg";
import uploadfileSvg from "../../assets/icons/uploadfile.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import criarPastaInputSvg from "../../assets/icons/criarpastainput.svg";
import infoPastaSvg from "../../assets/icons/pastaIcone.svg";
import icAtencao from "../../assets/icons/atencaoIcon.svg";
import iconNuvemArquivoSvg from "../../assets/icons/iconNuvemArquivo.svg";
import iconNuvemArquivoSvgSelect from "../../assets/icons/iconNuvemArquivoSelecionado.svg";
import ModalMoverArquivosPastas from "../../components/ModalMoverArquivosPastas";
import ModalCopiarArquivosPastas from "../../components/ModalCopiarArquivosPastas";
import moment from "moment";
import "./styles.scss";
import { CloseOutlined } from "@mui/icons-material";

import { LoadingOutlined } from "@ant-design/icons";
import lang from "../../assets/idioma/idiomas";
import { getListagemBanner } from "../../services/http/bannersServico";

let zip = require("jszip")();

const initTreeData = [
  {
    title: lang.Nuvem_de_arquivos,
    key: "0/NuvemArquivo",
    icon: <img src={iconNuvemArquivoSvg} />,
  },
];

const initialPastaAtualState = [];

const PageGaleriaMidia = ({ resultadoPesquisar }) => {
  const { compartilharpasta } = useParams();
  const [form] = Form.useForm();
  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const isMidia = services.storage.isMidia();
  const [dataSource, setDataSource] = useState([]);
  const [dataSourceLixeira, setDataSourceLixeira] = useState([]);
  const [modalAddPasta, setModalAddPasta] = useState(false);
  const [modalUpload, setModalUpload] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);
  const [modalRenomear, setModalRenomear] = useState(false);
  const [modalEditarPasta, setModalEditarPasta] = useState(false);
  const [modalEditarArquivo, setModalEditarArquivo] = useState(false);
  const [modalLinkUnico, setModalLinkUnico] = useState(false);
  const [modalLinkMultiplos, setModalLinkMultiplos] = useState(false);
  const [modalVisualizar, setModalVisualizar] = useState(false);
  const [modalCompartilhar, setModalCompartilhar] = useState(false);
  const [modalNovoCompartilhamento, setModalNovoCompartilhamento] =
    useState(false);
  const [modalCopiar, setModalCopiar] = useState(false);
  const [modalMover, setModalMover] = useState(false);
  const [modalRemoverConfirmacao, setModalRemoverConfirmacao] = useState(false);
  const [permissoes, setPermissoes] = useState([{}]);
  const [treeFolders, setTreeFolders] = useState([]);
  const [pastaDestino, setPastaDestino] = useState(null);
  const [pastaParaMim, setPastaParaMim] = useState(false);
  const [idInfo, setIdInfo] = useState("");
  const [tipoInfo, setTipoInfo] = useState("");
  const [idRenomear, setIdRenomear] = useState("");
  const [tipoRenomear, setTipoRenomear] = useState("");
  const [tipoEditar, setTipoEditar] = useState("");
  const [idEditar, setIdEditar] = useState("");
  const [showAdicionarPasta, setShowAdicionarPasta] = useState(true);
  const [mostrarListagemFavoritos, setMostrarListagemFavoritos] =
    useState(false);
  const [mostrarListagemInativos, setMostrarListagemInativos] = useState(false);
  const [mostrarListagemLinks, setMostrarListagemLinks] = useState(false);
  const [
    mostrarListagemPastasCompartilhadas,
    setMostrarListagemPastasCompartilhadas,
  ] = useState(false);
  const [mostrarListagemItensRecentes, setMostrarListagemItensRecentes] =
    useState(false);
  const [pastasCompartilhadasPorMim, setPastasCompartilhadasPorMim] =
    useState(false);
  const [pastasCompartilhadasParaMim, setPastasCompartilhadsParaMim] =
    useState(false);
  const [pastaAtual, setPastaAtual] = useState(initialPastaAtualState);
  const [linkUnicoGerado, setLinkUnicoGerado] = useState([{}]);
  const [nomeBuscar, setNomeBuscar] = useState("");
  const [expandedKeys, setExpandedKeys] = useState(["0/NuvemArquivo"]);
  const [selectedKeys, setSelectedKeys] = useState(["0/NuvemArquivo"]);
  const [arquivoVisualizar, setArquivoVisualizar] = useState(null);
  const [pastaVisualizar, setPastaVisualizar] = useState(null);
  const [pastaPaiDowload, setPastaPaiDownload] = useState(null);
  const [isSelectedAll, setSelectedAll] = useState(false);
  const [treeData, setTreeData] = useState(initTreeData);
  const [showTreeData, setShowTreeData] = useState(true);
  const [showModalMoverPastasArquivos, setShowModalMoverPastasArquivos] =
    useState(false);
  const [showModalCopiarPastasArquivos, setShowModalCopiarPastasArquivos] =
    useState(false);
  const [finalizarDownload, setFinalizarDownload] = useState(false);

  const [visualizarListagem, setVisualizarListagem] = useState(false);
  const [visualizarGaleria, setVisualizarGaleria] = useState(true);

  const [pastaACompartilhar, setPastaACompartilhar] = useState(null);
  const [visaoMobile, setVisaoMobile] = useState(false);

  const [algumCompartilhamento, setAlgumCompartilhamento] = useState(false);

  const [buscarPorNome, setBuscarPorNome] = useState("");
  const [menuSelecionado, setMenuSelecionado] = useState(0);
  const [paginaAtual, setPaginalAtual] = useState(1);
  const [itemSelecionadoCopiarMover, setItemSelecionadoCopiarMover] =
    useState(null);
  const [itensSelecionados, setItensSelecionados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lixeiraFilter, setLixeiraFilter] = useState({});
  const [showProgresso, setShowProgresso] = useState(false);
  const [atualizaArvoreDeletados, setAtualizaArvoreDeletados] = useState(false);
  const [mostrarPesquisaAvancada, setMostrarPesquisaAvancada] = useState(false);
  const [favoritarDesfavoritar, setFavoritarDesfavoritar] = useState(null);
  const [pageFilho, setPageFilho] = useState(null);
  const [pesquisar, setPesquisar] = useState("");
  const [paginar, setPaginar] = useState(1); // definindo valor inicial para paginar
  const [colunaOrdenada, setColunaOrdenada] = useState("");
  const [colunaPadrao, setColunaPadrao] = useState("");
  const [ordenacao, setOrdenacao] = useState("");
  const [local, setLocal] = useState("");
  const [infoFilhas, setInfoFilhas] = useState("");

  useEffect(() => {
    const updatedTreeData = [...treeData];
    const cloudNodeIndex = updatedTreeData.findIndex(
      (node) => node.key === "0/NuvemArquivo"
    );

    if (cloudNodeIndex !== -1) {
      const icon = selectedKeys.includes("0/NuvemArquivo")
        ? iconNuvemArquivoSvgSelect
        : iconNuvemArquivoSvg;
      updatedTreeData[cloudNodeIndex].icon = <img src={icon} />;
      setTreeData(updatedTreeData);
    }
  }, [selectedKeys]);
  useEffect(() => {
    if (compartilharpasta) {
      buscarPermissoes();
      listagemPastas();
      handleComartilhadoPorMim(1, 10, null);
      setMostrarListagemFavoritos(false);
      setShowAdicionarPasta(false);
      setMostrarListagemInativos(false);
      setMostrarListagemLinks(false);
      setMostrarListagemItensRecentes(false);
      setAtividadeRecenteSelecionada(false);
      setMostrarListagemPastasCompartilhadas(true);
      setMenuSelecionado(5);
    } else {
      buscarPermissoes();
      listagemPastas();
      listarPastasArquivosRaiz(1);
    }

    if (window.innerWidth <= 699) {
      setVisualizarListagem(false);
      setVisualizarGaleria(true);
      setVisaoMobile(true);
    }
    setLoading(false);
    setItensSelecionados([]);
  }, []);

  useEffect(() => {
    const download = async () => {
      await finalizarDownloadPasta();

      setPastaPaiDownload(null);
      setFinalizarDownload(false);
    };

    if (
      pastaPaiDowload &&
      pastaPaiDowload?.arquivosPastas.length > 0 &&
      finalizarDownload == true
    ) {
      zip = require("jszip")();
      download();
    }
  }, [finalizarDownload, pastaPaiDowload]);

  useEffect(() => {
    if (buscarPorNome) {
      setItensSelecionados([]);
      if (mostrarListagem) {
        pesquisarPorNome(buscarPorNome, 1);
      } else if (
        mostrarListagemPastasCompartilhadas &&
        pastasCompartilhadasPorMim
      ) {
        handleComartilhadoPorMim(1, 10, buscarPorNome);
      } else if (
        mostrarListagemPastasCompartilhadas &&
        pastasCompartilhadasParaMim
      ) {
        handleComartilhadoPorMim(1, 10, buscarPorNome);
      } else if (mostrarListagemLinks) {
        listarLinksCompartilhados(1, buscarPorNome);
      }
    }
  }, [buscarPorNome]);

  useEffect(() => {
    setItensSelecionados([]);
    setBuscarPorNome("");
  }, [menuSelecionado]);

  useEffect(() => {
    if (dataSource?.page) {
      setPaginalAtual(dataSource.page);
    }

    formatarDataSource();
  }, [dataSource]);

  useEffect(() => {
    if (!mostrarListagemInativos) return;
    if (
      (!lixeiraFilter?.dataDescarte &&
        !lixeiraFilter?.mesDescarte &&
        !lixeiraFilter?.anoDescarte &&
        !lixeiraFilter?.autor) ||
      (lixeiraFilter?.dataDescarte &&
        new moment(lixeiraFilter?.dataDescarte).year() > 1000) ||
      lixeiraFilter?.mesDescarte ||
      (lixeiraFilter?.anoDescarte && lixeiraFilter?.anoDescarte > 1000) ||
      lixeiraFilter?.autor
    )
      listarLixeira(paginaAtual);
  }, [lixeiraFilter]);

  const formatarDataSource = () => {
    if (dataSource?.lista?.length > 0) {
      let newDataSource = [...dataSource.lista];

      let newLista = newDataSource.map((item) => {
        if (
          itensSelecionados.length > 0 &&
          itensSelecionados.findIndex((x) => x.id == item.id) >= 0
        ) {
          return {
            ...item,
            checked: true,
          };
        } else {
          return {
            ...item,
            checked: false,
          };
        }
      });
      dataSource.lista = newLista;
      setDataSource(dataSource);
    }
  };

  const selecionarItem = (e, item) => {
    const indexItem = dataSource?.lista?.findIndex((x) => x.id == item.id);

    if (e) {
      let findExists = itensSelecionados.find((x) => x.id == item.id);
      if (!findExists) {
        dataSource.lista[indexItem].checked = e;
        setDataSource(dataSource);
        setItensSelecionados((prevent) => [...prevent, item]);
      } else {
        return;
      }
    } else {
      dataSource.lista[indexItem].checked = e;
      setDataSource(dataSource);
      let newArray = [...itensSelecionados];

      let index = newArray.findIndex((x) => x.id == item.id);

      if (index >= 0) {
        newArray.splice(index, 1);
        setItensSelecionados(newArray);
      }
    }
  };

  useEffect(() => {
    if (dataSource?.lista?.length == itensSelecionados.length) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  }, [selecionarItem]);

  const marcarTodos = (value, list) => {
    if (value) {
      dataSource?.lista.map((item) => {
        item.checked = value;
      });

      setDataSource(dataSource);
      setSelectedAll(true);
      setItensSelecionados((prevent) => [...dataSource?.lista]);
    } else {
      dataSource?.lista.map((item) => {
        item.checked = value;
      });
      setSelectedAll(false);
      setItensSelecionados([]);
    }
  };

  const handleEfetuarDownload = async () => {
    setLoading(true);
    if (itensSelecionados.length <= 0) {
      setLoading(false);
      message.warning(lang.Selecione_pasta_ou_arquivo_para_download);
      return;
    }

    for (const item of itensSelecionados) {
      await downloadFile(item);
    }

    setLoading(false);
  };

  const MoverDocumentos = () => {
    if (itensSelecionados.length <= 0) {
      message.warning(lang.Selecione_pasta_ou_arquivo_para_mover);
      return;
    }

    setShowModalMoverPastasArquivos(true);
  };

  const CopiarDocumentos = () => {
    if (itensSelecionados.length <= 0) {
      message.warning(lang.Selecione_pasta_ou_arquivo_para_copiar);
      return;
    }

    setShowModalCopiarPastasArquivos(true);
  };

  const RemoverDocumentos = () => {
    if (itensSelecionados.length <= 0) {
      message.warning(lang.Selecione_pasta_ou_arquivo_para_remover);
      return;
    }
    showModalRemoverConfirmacao();
  };

  const removerSelecionados = async () => {
    closeModalRemoverConfirmacao();
    setLoading(true);

    let arrayArquivos = [];
    let arrayPastas = [];

    for (const item of itensSelecionados) {
      if (item.tipo == 0) {
        arrayPastas.push(item.id);
      } else {
        arrayArquivos.push(item.id);
      }
    }

    let responseArquivos = await inativarArquivos(arrayArquivos, IdUser);
    let responsePastas = await inativarPastas(arrayPastas, IdUser);

    if (!responseArquivos.fail && !responsePastas.fail) {
      setItensSelecionados([]);
      setLoading(false);
      message.success(lang.Item_removido_com_sucesso);
      mudarPaginaArquivoPastas(1);
      pesquisarPastasArquivos("", 1);
    } else {
      setLoading(false);
      message.warning(lang.Ocorreu_falha_no_processamento);

      if (!responseArquivos.fail) {
        mudarPaginaArquivoPastas(1);
        pesquisarPastasArquivos("", 1);
      }

      if (!responsePastas.fail) {
        mudarPaginaArquivoPastas(1);
        pesquisarPastasArquivos("", 1);
      }
    }
  };

  const downloadArquivos = async (idPastaPai, folderObj) => {
    let arquivos = pastaPaiDowload?.arquivosPastas
      .filter((x) => x.tipo == 1 && x.idParent == idPastaPai)
      .sort((x) => x.nome);
    for (const arq of arquivos) {
      let nome = arq.nome;
      let nomeRepetido = arquivos.find(
        (x) => x.nome == arq.nome && x.id != arq.id
      );
      if (nomeRepetido) {
        let indice = arquivos.findIndex((x) => x.id == arq.id);

        if (indice > 0) {
          let nomeNovo = nome.split(".");
          if (nomeNovo.length > 0)
            nome = nomeNovo[0] + " (" + indice + ")." + nomeNovo[1];
          else nome = nomeNovo[0] + " (" + indice + ")";
        }
      }
      try {
        folderObj.file(nome, arq.baixado, { binary: true });
      } catch (err) {
        console.error(err);
        continue;
      }
    }
  };

  const downloadArquivosPasta = async (idPastaPai, folderObj) => {
    let pastaPai = pastaPaiDowload?.arquivosPastas.filter(
      (x) => x.tipo == 0 && x.idParent == idPastaPai
    );
    await downloadArquivos(idPastaPai, folderObj);

    for (const pasta of pastaPai) {
      let folder = folderObj.folder(pasta.nome);
      await downloadArquivosPasta(pasta.id, folder);
      await downloadArquivos(pasta.id, folder);
    }
  };

  const finalizarDownloadPasta = async () => {
    if (pastaPaiDowload != null) {
      await downloadArquivos(pastaPaiDowload.id, zip);

      let pastaPai = pastaPaiDowload.arquivosPastas.filter(
        (x) => x.tipo == 0 && x.idParent == pastaPaiDowload.id
      );

      for (const pasta of pastaPai) {
        let folder = zip.folder(pasta.nome);
        await downloadArquivosPasta(pasta.id, folder);
      }
    }

    const content = await zip.generateAsync({
      type: "blob",
      compression: "DEFLATE",
      compressionOptions: {
        level: 8,
      },
      streamFiles: true,
    });

    await registrarDownloadPasta(pastaPaiDowload.id);
    saveAs(
      content,
      !pastaPaiDowload.nome.includes(".")
        ? pastaPaiDowload.nome
        : pastaPaiDowload.nome + ".zip"
    );
  };

  const downloadFile = async (item) => {
    if (item) {
      setLoading(true);
      if (item.tipo == 0) {
        item.arquivosPastas = await downloadBuscarItensFilhos(item.id, []);
        setPastaPaiDownload(item);
        setFinalizarDownload(true);
        setLoading(false);
      } else {
        registrarDownloadArquivo(item.id);
        saveAs(item.urlArquivo, item.nome);
        setLoading(false);
      }
    }
  };

  const downloadBuscarItensFilhos = async (idPastaPai, arrayArquivosPastas) => {
    let arrayResponsePastas = [];
    let arrayResponseArquivos = [];
    const res = await obterPastasArquivosFilhos(idPastaPai, 1000, 1, ordenacao);
    if (!res.fail && res.data) {
      res.data.lista.forEach((element) => {
        element.baixado = null;
        if (element.tipo == 0) {
          arrayResponsePastas.push(element);
        } else {
          arrayResponseArquivos.push(element);
        }
      });
    } else {
    }

    if (arrayResponsePastas.length > 0) {
      for (const pasta of arrayResponsePastas) {
        arrayArquivosPastas.push(pasta);
        await downloadBuscarItensFilhos(pasta.id, arrayArquivosPastas);
      }
    }

    if (arrayResponseArquivos.length > 0) {
      for (const itemArquivo of arrayResponseArquivos) {
        if (itemArquivo.urlArquivo) {
          try {
            const arquivoBaixado = await axios
              .create()
              .get(itemArquivo.urlArquivo, {
                responseType: "arraybuffer",
              });

            if (arquivoBaixado.status != 500 && arquivoBaixado.status != 400) {
              if (
                arquivoBaixado.data &&
                String(arquivoBaixado.data).length > 0
              ) {
                let arquivoToBase64 = Buffer.from(
                  arquivoBaixado.data,
                  "binary"
                );

                itemArquivo.baixado = arquivoToBase64;
                arrayArquivosPastas.push(itemArquivo);
              }
            } else {
              continue;
            }
          } catch (err) {
            console.error(err);
            continue;
          }
        }
      }
    }
    return arrayArquivosPastas;
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return { ...node, children };
      }

      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }

      return node;
    });
  };

  const updateTreeDataAUX = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return { ...node, children };
      }

      if (node.children) {
        return { ...node, children };
      }

      return node;
    });
  };

  useEffect(() => {
    setTimeout(() => {
      onLoadData({ key: "0" });
    }, 500);
  }, [modalRenomear, atualizaArvoreDeletados]);

  const onLoadData = ({ key, children }) =>
    new Promise((resolve) => {
      if (key.split("/")[0] == "0") {
        trackPromise(
          listarPastas(IdUser, 1, 1000)
            .then((res) => {
              if (!res.fail && res.data) {
                let array = [];
                res.data.lista.forEach((element) => {
                  array.push({
                    title: (
                      <div className="pegarId" id={element.id}>
                        {element.nome}
                      </div>
                    ),
                    key: `${element.id}/${element.nome}`,
                  });
                });

                setTreeData((origin) => updateTreeData(origin, key, array));
                setTreeData((origin) => updateTreeDataAUX(origin, key, array));
              }

              resolve();
            })
            .catch((error) => {
              console.error(error);
            })
        );
      } else {
        let [idPastaSelecionada, nomePastaSelecionada] = key.split("/");
        trackPromise(
          listarPastaFilha(idPastaSelecionada)
            .then((res) => {
              if (!res.fail && res.data) {
                let array = [];
                res.data.forEach((element) => {
                  if (element.tipo == 0) {
                    array.push({
                      title: (
                        <div className="pegarId" id={element.id}>
                          {element.nome}
                        </div>
                      ),
                      key: `${element.id}/${element.nome}`,
                    });
                  }
                });
                setTreeData((origin) => updateTreeData(origin, key, array));
                registrarVisualizacaoPastas(idPastaSelecionada, false);
              }

              resolve();
            })
            .catch((error) => {
              console.error(error);
            })
        );
      }
    });

  const favoritar = (documento) => {
    if (documento.ehFavorito) {
      message.warning(
        `${documento.tipo == 0 ? "Pasta" : "Arquivo"} já está nos favoritos.`
      );
    } else {
      let data = {
        idDocumento: documento.id,
        idUsuario: IdUser,
        tipoDocumento: documento.tipo,
      };

      trackPromise(
        favoritarDocumento(data)
          .then((res) => {
            if (!res.fail) {
              message.success(
                `${
                  documento.tipo == 0 ? "Pasta incluída" : "Arquivo incluído"
                } aos favoritos com sucesso.`
              );
              setFavoritarDesfavoritar(true);
              setArquivoVisualizar({ ...documento, ehFavorito: true }); // atualiza a janela de pré-visualização e download
              mudarPaginaArquivoPastas(paginaAtual); // recarrega a listagem
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const listaDeFavoritos = (page) => {
    setBuscarPorNome("");
    setLocal("favorito");
    trackPromise(
      listarFavoritos(IdUser, page ? page : 1, ordenacao)
        .then((res) => {
          if (!res.fail && res.data) {
            setShowAdicionarPasta(false);
            setMostrarListagemInativos(false);
            setMostrarListagemLinks(false);
            setMostrarListagemPastasCompartilhadas(false);
            setMostrarListagemItensRecentes(false);
            setAtividadeRecenteSelecionada(false);
            setMostrarListagemFavoritos(true);
            setMenuSelecionado(2);
            setDataSource(res.data);
            ///////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleRemoverFavorito = (documento) => {
    let data = {
      idDocumento: documento.id,
      idUsuario: IdUser,
      tipoDocumento: documento.tipo,
    };

    trackPromise(
      removerFavorito(data)
        .then((res) => {
          if (!res.fail) {
            message.success(
              `${
                documento.tipo == 0 ? "Pasta removida" : "Arquivo removido"
              } dos favoritos com sucesso`
            );
            setFavoritarDesfavoritar(false);
            setArquivoVisualizar({ ...documento, ehFavorito: false }); // atualiza a janela de pré-visualização e download
            mudarPaginaArquivoPastas(paginaAtual); // recarrega a listagem
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleRemoverLink = (idDocumento) => {
    trackPromise(
      removerLink(idDocumento)
        .then((res) => {
          if (!res.fail) {
            message.success(lang.Link_removido_com_sucesso);
            mudarPaginaArquivoPastas(1);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const listarLinksCompartilhados = (page, nomeDocumento) => {
    setLocal("linkCompartilhado");
    trackPromise(
      obterLinks(IdUser, page, 10, nomeDocumento, ordenacao)
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
            setMenuSelecionado(4);
            setMostrarListagemFavoritos(false);
            setShowAdicionarPasta(false);
            setMostrarListagemInativos(false);
            setMostrarListagemPastasCompartilhadas(false);
            setMostrarListagemItensRecentes(false);
            setAtividadeRecenteSelecionada(false);
            setMostrarListagemLinks(true);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const listarPastasCompartilhadas = (page, nomeDocumento) => {
    let nome = nomeDocumento != null ? nomeDocumento : "";

    handleCompartilhadoComigo(1, 10, null);

    setMostrarListagemFavoritos(false);
    setShowAdicionarPasta(false);
    setMostrarListagemInativos(false);
    setMostrarListagemLinks(false);
    setMostrarListagemItensRecentes(false);
    setAtividadeRecenteSelecionada(false);
    setMostrarListagemPastasCompartilhadas(true);
    setMenuSelecionado(5);
  };

  const historicoPastaRaizes = (
    idPasta,
    nomePasta,
    atualizarExpanded = true
  ) => {
    let tree = [];
    const pastaSelecionada = {
      name: nomePasta,
      id: idPasta,
    };

    trackPromise(
      historicoPastaAberta(idPasta)
        .then((res) => {
          res.data.push({
            name: "Nuvem de arquivos",
            id: "0",
          });
          res.data.reverse();
          res.data.push(pastaSelecionada);
          setPastaAtual(res.data);

          if (atualizarExpanded) {
            res.data.forEach((pasta) => {
              if (pasta.id === "0") tree.push("0/NuvemArquivo");
              else tree.push(pasta.id + "/" + pasta.name);
            });
            setExpandedKeys(tree);
          }
          if (pastaSelecionada.id === "0") setSelectedKeys(["0/NuvemArquivo"]);
          else
            setSelectedKeys([
              pastaSelecionada.id + "/" + pastaSelecionada.name,
            ]);
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const changeNavegacao = (id, tipo, nomePasta = "") => {
    incluirPastaSelecionada(id, tipo, nomePasta, true);
  };

  const [compartilharPastaAnterior, setCompartilharPastaAnterior] = useState(
    {}
  );
  const [PastaAnteriorVerifica, setPastaAnteriorVerifica] = useState(false);

  const incluirPastaSelecionada = (
    id,
    tipo,
    nomePasta = "",
    atualizarExpanded = true
  ) => {
    if ((tipo == "pasta" || tipo == 0) && id != "0") {
      setMostrarListagemInativos(false);
      setMostrarListagemLinks(false);
      setMostrarListagemFavoritos(false);
      setMostrarListagemPastasCompartilhadas(false);
      setMostrarListagemItensRecentes(false);
      setAtividadeRecenteSelecionada(false);
      historicoPastaRaizes(id, nomePasta, atualizarExpanded);
      setMenuSelecionado(0);
      setInfoFilhas(id);
      buscarPastasFilhas(id, "pasta");
      setLocal("filho");
      setPageFilho(1);
      trackPromise(
        detalhesPasta(id)
          .then((res) => {
            if (!res.fail && res.data) {
              const pasta = res.data;
              setPastaAnteriorVerifica(true);
              setCompartilharPastaAnterior(pasta);
              setPastaDestino({
                id: pasta.id,
                nome: pasta.nome,
                permissoes: pasta.permissoes,
              });
            }
            registrarVisualizacaoPastas(id);
          })
          .catch((error) => {
            console.error(error);
          })
      );
      setShowAdicionarPasta(true);
    } else if (
      id == "0" &&
      (nomePasta == "NuvemArquivo" ||
        nomePasta == "Nuvem de arquivos" ||
        nomePasta == "Nuvem") &&
      (tipo == "pasta" || tipo == 0)
    ) {
      setMostrarListagemInativos(false);
      setNomeBuscar("");
      setPastaAtual(initialPastaAtualState);
      setPastaDestino(null);
      setShowAdicionarPasta(true);
      setMenuSelecionado(0);
      listarPastasArquivosRaiz(1);
      if (atualizarExpanded) setExpandedKeys(["0/NuvemArquivo"]);

      setSelectedKeys(["0/NuvemArquivo"]);
    } else {
      return;
    }
  };

  const pastaExpandida = (value) => {
    setExpandedKeys(value);
  };

  const pastaSelecionada = (value) => {
    if (value[0] != "0" && value[0] != null && value[0] != undefined) {
      let [idPastaSelecionada, nomePastaSelecionada] = value[0].split("/");
      incluirPastaSelecionada(
        idPastaSelecionada,
        "pasta",
        nomePastaSelecionada,
        false
      );
    } else {
      incluirPastaSelecionada("0", "pasta", "NuvemArquivo");
    }
  };
  const removerItem = (id, tipo) => {
    setAtualizaArvoreDeletados(false);
    if (tipo == "pasta") {
      trackPromise(
        inativarPasta(id, IdUser)
          .then((res) => {
            if (!res.fail) {
              setAtualizaArvoreDeletados(true);
              message.success(lang.Pasta_removida_com_sucesso);
              mudarPaginaArquivoPastas(1);
              pesquisarPastasArquivos("", 1);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      trackPromise(
        inativarArquivo(id, IdUser)
          .then((res) => {
            if (!res.fail) {
              setAtualizaArvoreDeletados(true);
              message.success(lang.Arquivo_removido_com_sucesso);
              mudarPaginaArquivoPastas(1);
              pesquisarPastasArquivos("", 1);
            } else {
              if (res.errors[0].menssagem != undefined) {
                message.warning(res.errors[0].menssagem);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const listagemPastas = () => {
    trackPromise(
      listarPastas(IdUser, 1, 1000)
        .then((res) => {
          if (!res.fail && res.data) {
            setTreeFolders(res.data.lista);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const aumentarPaginaLixeira = (pageSize) => {
    listarLixeira(paginaAtual, pageSize);
  };

  const listarLixeira = (page, pageSize = 10) => {
    setLocal("lixeira");
    if (page != "") {
      let filter = "";
      if (lixeiraFilter?.dataDescarte)
        filter += "&dataInativacao=" + lixeiraFilter.dataDescarte;

      if (lixeiraFilter?.mesDescarte)
        filter += "&mesInativacao=" + lixeiraFilter.mesDescarte;

      if (lixeiraFilter?.anoDescarte)
        filter += "&anoInativacao=" + lixeiraFilter.anoDescarte;

      if (lixeiraFilter?.autor) filter += "&usuario=" + lixeiraFilter.autor;

      if (filter?.substring(0, 1) === "&")
        filter = "?" + filter.substring(1, filter.length);
      trackPromise(
        listarPastasArquivosInativos(pageSize, page, filter, ordenacao)
          .then((res) => {
            if (!res.fail && res.data) {
              setShowAdicionarPasta(false);
              setMostrarListagemFavoritos(false);
              setMostrarListagemLinks(false);
              setMostrarListagemPastasCompartilhadas(false);
              setMostrarListagemItensRecentes(false);
              setAtividadeRecenteSelecionada(false);
              setMostrarListagemInativos(true);
              setMenuSelecionado(3);
              setDataSourceLixeira(res.data);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      setPaginalAtual(null);
    }
  };

  const handleListarAtividadeRecentes = (pagina) => {
    setLocal("atividadesRecentes");
    trackPromise(
      listarAtividadesRecentes(pagina, 10)
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
            setShowAdicionarPasta(false);
            setMostrarListagemFavoritos(false);
            setMostrarListagemLinks(false);
            setMostrarListagemPastasCompartilhadas(false);
            setMostrarListagemInativos(false);
            setAtividadeRecenteSelecionada(false);
            setMostrarListagemItensRecentes(true);
            setMenuSelecionado(1);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const restaurarArquivoPasta = (id, tipo) => {
    if (tipo == "pasta") {
      trackPromise(
        ativarPasta(id)
          .then((res) => {
            if (!res.fail) {
              listarLixeira(1);
              message.success(lang.Restaurado_com_sucesso);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      trackPromise(
        ativarArquivo(IdUser, id)
          .then((res) => {
            if (!res.fail) {
              listarLixeira(1);
              message.success(lang.Restaurado_com_sucesso);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const removerLixeira = () => {
    setShowProgresso(true);

    trackPromise(
      esvaziarLixeira()
        .then((res) => {
          if (!res.fail) {
            setShowProgresso(false);

            message.success(lang.Lixeira_esvaziada_com_sucesso);
            setDataSourceLixeira([]);

            setShowTreeData(false);

            setTimeout(() => {
              setShowTreeData(true);
            }, 2);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const showInfo = (id, tipo) => {
    setIdInfo(id);
    setTipoInfo(tipo);
    showModalInfo();
  };

  const showRenomear = (id, tipo) => {
    setIdRenomear(id);
    setTipoRenomear(tipo);
    setTimeout(() => {
      showModalRenomear();
    }, 100);
  };

  //renomeia a tabela
  const renomearItemTable = (id, valorNome, list) => {
    // id = "idPasta" valorNome = "nomePasta"

    if (dataSource?.lista?.length) {
      const newSource = { ...dataSource };
      const index = newSource.lista.findIndex((x) => x.id === id);
      newSource.lista[index].nome = valorNome;
      setDataSource(newSource);
    }
  };

  const showEditar = (id, tipo) => {
    var t = tipo;
    setIdEditar(id);
    setTipoEditar(tipo);

    if (tipo == 0) {
      t = "pasta";
    }

    if (tipo == 1) {
      t = "arquivo";
    }

    if (t == "pasta") {
      showEditarPasta();
    } else {
      showEditarArquivo();
    }
  };

  const buscarPermissoes = () => {
    trackPromise(
      listarPermissoes()
        .then((res) => {
          if (!res.fail && res.data) {
            setPermissoes(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const pesquisarPastasArquivos = (page) => {
    setPageFilho(page);
    if (pastaDestino && pastaDestino.id != "0") {
      trackPromise(
        obterPastasArquivosFilhos(pastaDestino.id, 10, page, ordenacao)
          .then((res) => {
            if (!res.fail && res.data) {
              setDataSource(res.data);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      listarPastasArquivosRaiz(page);
    }
  };

  const pesquisarPorNome = (value, page) => {
    setPesquisar(value);
    setPaginar(page);
    setLocal("filtro");
  };

  useEffect(() => {
    let timerId;
    if (pesquisar.length > 1) {
      timerId = setTimeout(() => {
        trackPromise(
          listarPastasPorFiltro(IdUser, paginar, 10, pesquisar)
            .then((res) => {
              if (!res.fail && res.data) {
                setDataSource(res.data);
              }
            })
            .catch((error) => {
              console.error(error);
            })
        );
      }, 800);
    } else {
      listarPastasArquivosRaiz(1);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [pesquisar, paginar]);

  useEffect(() => {
    setOrdenacao("");
  }, [local]);

  const listarPastasArquivosRaiz = (page) => {
    setPaginar(page);
    // passando ordenação como parâmetro
    trackPromise(
      listarPastasArquivos(IdUser, paginar, 10, ordenacao) // passando ordenação como parâmetro
        .then((res) => {
          setLocal("pai");
          setPastaAnteriorVerifica(false);
          if (!res.fail && res.data) {
            setShowAdicionarPasta(true);
            setMostrarListagemFavoritos(false);
            setMostrarListagemLinks(false);
            setMostrarListagemPastasCompartilhadas(false);
            setMostrarListagemItensRecentes(false);
            setAtividadeRecenteSelecionada(false);
            setMostrarListagemInativos(false);
            setMenuSelecionado(0);
            setDataSource(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const listarPastaArquivo = (value, page) => {
    var paginaAtualRetorno = paginaAtual;
    pesquisarPastasArquivos(paginaAtualRetorno);
  };
  const buscarPastasFilhas = (idPasta, tipo, page) => {
    // passando ordenação como parâmetro
    if (tipo === "pasta") {
      trackPromise(
        //idPasta, tamanho = 10, page, ordem
        obterPastasArquivosFilhos(idPasta, 10, page ? page : 1, ordenacao) // passando ordenação como parâmetro
          .then((res) => {
            if (!res.fail && res.data) {
              setShowAdicionarPasta(true);
              setMostrarListagemFavoritos(false);
              setMostrarListagemLinks(false);
              setMostrarListagemPastasCompartilhadas(false);
              setMostrarListagemItensRecentes(false);
              setAtividadeRecenteSelecionada(false);
              setMostrarListagemInativos(false);
              setMenuSelecionado(0);
              setDataSource(res.data);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  function listarPastasFiltro(ordenar) {
    trackPromise(
      listarPastasPorFiltro(IdUser, paginar, 10, pesquisar, ordenar)
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  }

  useEffect(() => {
    setNomeBuscar(pesquisar);

    if (local === "filho") {
      buscarPastasFilhas(infoFilhas, "pasta", pageFilho, ordenacao);
    }

    if (local === "pai") {
      listarPastasArquivosRaiz(paginar, ordenacao);
    }
    if (local === "lixeira") {
      listarLixeira(paginar);
    }
    if (local === "favorito") {
      listaDeFavoritos(paginar);
    }
    if (local === "linkCompartilhado") {
      listarLinksCompartilhados(paginar, null);
    }
    if (local === "compartilhadoComigo") {
      handleCompartilhadoComigo(1, 10, null, paginar);
    }
    if (local === "compartilhadoPorMim") {
      handleComartilhadoPorMim(1, 10, null, paginar);
    }

    let timerId;
    if (
      pesquisar &&
      local !== "filho" &&
      local !== "pai" &&
      local !== "lixeira" &&
      local !== "favorito" &&
      local != "linkCompartilhado" &&
      local != "compartilhadoComigo" &&
      local != "compartilhadoPorMim"
    ) {
      timerId = setTimeout(() => {
        listarPastasFiltro(ordenacao); // passando ordenação como parâmetro
      }, 800);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [pesquisar, ordenacao, paginar, infoFilhas, local]);

  const mudarPaginaArquivoPastas = (page) => {
    if (mostrarListagemFavoritos) {
      listaDeFavoritos(page);
    } else if (showAdicionarPasta) {
      nomeBuscar
        ? pesquisarPorNome(nomeBuscar, page)
        : pesquisarPastasArquivos(page);
    } else if (mostrarListagemLinks) {
      nomeBuscar
        ? listarLinksCompartilhados(page, nomeBuscar)
        : listarLinksCompartilhados(page, null);
    } else if (mostrarListagemFavoritos) {
      nomeBuscar ? listaDeFavoritos(page) : listaDeFavoritos(page);
    } else if (mostrarListagemInativos) {
      nomeBuscar ? listarLixeira(page) : listarLixeira(page);
    } else if (mostrarListagemPastasCompartilhadas) {
      if (pastasCompartilhadasParaMim) {
        nomeBuscar
          ? handleCompartilhadoComigo(page, 10, nomeBuscar)
          : handleCompartilhadoComigo(page, 10, "");
      }

      if (pastasCompartilhadasPorMim) {
        nomeBuscar
          ? handleComartilhadoPorMim(page, 10, nomeBuscar)
          : handleComartilhadoPorMim(page, 10, "");
      }
    }
  };

  const atualizarPastasDragInDrop = (data) => {
    if (data) {
      trackPromise(
        moverPastaArquivoDragInDrop(data)
          .then((res) => {
            if (!res.fail) {
              mudarPaginaArquivoPastas(1);
              setShowTreeData(false);
              setTimeout(() => {
                setShowTreeData(true);
              }, 2);
              onLoadData({ key: "0" })
                .then((res) => {
                  setShowTreeData(true);
                })
                .catch((error) => console.error(error));
            } else {
              if (res.errors[0].message != undefined) {
                message.warning(res.errors[0].message);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const onSubmit = (values) => {
    setLoading(true);
    closeModalPasta();

    let data = {
      nomePasta: values.nomePasta,
      classificacao: 0,
      autor: login,
      tamanho: 0,
      tipoDocumento: 0,
      idParent: pastaDestino != null ? pastaDestino.id : null,
      idUsuarioOcultou: !isMidia && pastaParaMim ? IdUser : null,
    };

    trackPromise(
      criarPasta(data)
        .then((res) => {
          if (!res.fail) {
            message.success(lang.Pasta_criada_com_sucesso);
            incluirPastaSelecionada(res.data.id, "pasta", values.nomePasta);
            form.resetFields();
            setLoading(false);
            setPastaParaMim(false);
            setShowTreeData(false);
            onLoadData({ key: "0" })
              .then((res) => {
                setShowTreeData(true);
              })
              .catch((error) => console.error(error));
          } else {
            showModalPasta();
            setLoading(false);
          }
        })
        .catch((error) => {
          showModalPasta();
          setLoading(false);
          console.error(error);
        })
    );
  };

  const mostrarTitulo = () => {
    if (showAdicionarPasta) {
      return <span className="titulo-nuvem">Nuvem de arquivos</span>;
    } else if (mostrarListagemFavoritos) {
      return <span className="titulo-listagem">Favoritos</span>;
    } else if (mostrarListagemInativos) {
      return <span className="titulo-listagem">Lixeira</span>;
    } else if (mostrarListagemItensRecentes) {
      return <span className="titulo-listagem">Atividades recentes</span>;
    } else if (mostrarListagemLinks) {
      return <span className="titulo-listagem">Links públicos</span>;
    } else if (mostrarListagemPastasCompartilhadas) {
      return (
        <div className="div-opcao-pasta-compartilhada">
          <span
            className={
              pastasCompartilhadasParaMim
                ? "span-listatagem-pastas-compartilhadas"
                : "span-compartilhados-nao-selecionado"
            }
            onClick={() => handleCompartilhadoComigo(1, 10, null)}
          >
            Compartilhadas comigo
          </span>
          <span
            className={
              pastasCompartilhadasPorMim
                ? "span-listatagem-pastas-compartilhadas"
                : "span-compartilhados-nao-selecionado"
            }
            style={{ marginLeft: "1.5rem" }}
            onClick={() => handleComartilhadoPorMim(1, 10, null)}
          >
            Compartilhadas por mim
          </span>
        </div>
      );
    }
  };

  const handleGerarMultiplosLinks = (item) => {
    const arrayData = [];

    if (item != null && item.lista.length > 0) {
      item.lista.forEach((documento) => {
        arrayData.push({
          idUsuario: IdUser,
          idDocumento: documento.id,
          tipoDocumento: documento.tipo,
          dataValidade: null,
          senha: null,
        });
      });

      trackPromise(
        gerarLinkMultiplo(arrayData)
          .then((res) => {
            if (!res.fail && res.data) {
              setLinkUnicoGerado(res.data);

              closeModalLinkMultiplos();

              setTimeout(() => {
                showModalLinkUnico();
              }, 100);
              listarLinksCompartilhados(1, null);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const handleGerarLinkUnico = (item) => {
    const data = {
      idUsuario: IdUser,
      idDocumento: item.id,
      tipoDocumento: item.tipo,
      dataValidade: null,
      senha: null,
    };

    trackPromise(
      gerarLinkUnico(data)
        .then((res) => {
          if (!res.fail && res.data) {
            let array = [];
            array.push(res.data);

            setLinkUnicoGerado(array);

            setTimeout(() => {
              showModalLinkUnico();
            }, 100);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleCompartilhar = (pasta, usuarios) => {
    let arrayUsuarios = [];

    Array(usuarios).forEach((item) => {
      arrayUsuarios.push(item.id);
    });

    let data;
    if (pasta.tipo == 1) {
      data = {
        idUsuarioDonoCompartilhamento: IdUser,
        idArquivo: pasta.id,
        idPasta: pasta.idParent,
        idUsuariosAcesso: usuarios.map((item) => {
          return item.id;
        }),
      };
    } else {
      data = {
        idUsuarioDonoCompartilhamento: IdUser,
        idPasta: pasta.id,
        idArquivo: null,
        idUsuariosAcesso: usuarios.map((item) => {
          return item.id;
        }),
      };
    }

    trackPromise(
      compartilharPasta(data)
        .then((res) => {
          if (!res.fail && pasta.tipo == 0) {
            message.success(lang.Pasta_compartilhada_com_sucesso);
          } else if (!res.fail && pasta.tipo == 1) {
            message.success(lang.Arquivo_compartilhado_com_sucesso);
          } else {
            message.success(res.errors[0].menssagem);
          }

          // handleComartilhadoPorMim(1, 10, null);
          closeModalCompartilhar();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleRemoverCompartilhar = (pasta) => {
    trackPromise(
      removerCompartilhamento(IdUser, pasta.id)
        .then((res) => {
          if (!res.fail) {
            message.success(lang.Compartilhamento_removido_com_sucesso);
            closeModalCompartilhar();
            handleComartilhadoPorMim(1, 10, null);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleSairCompartilhamento = (pasta) => {
    trackPromise(
      sairDoCompartilhametno(IdUser, pasta.id)
        .then((res) => {
          if (!res.fail) {
            message.success(
              "Você saiu do compartilhamento da pasta selecionada"
            );
            handleCompartilhadoComigo(1, 10, null);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleCompartilhadoComigo = (pagina, tamanho, nomeDocumento) => {
    setLocal("compartilhadoComigo");
    trackPromise(
      listarPastasCompartilhadasComigo(
        IdUser,
        tamanho,
        pagina,
        nomeDocumento,
        ordenacao
      )
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
            setPastasCompartilhadasPorMim(false);
            setAlgumCompartilhamento(true);
            setPastasCompartilhadsParaMim(true);
          } else {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleComartilhadoPorMim = (pagina, tamanho, nomeDocumento) => {
    setLocal("compartilhadoPorMim");
    trackPromise(
      listarPastasCompartilhadasPorMim(
        IdUser,
        tamanho,
        pagina,
        nomeDocumento,
        ordenacao
      )
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
            setPastasCompartilhadsParaMim(false);
            setAlgumCompartilhamento(true);
            setPastasCompartilhadasPorMim(true);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const [enviaIdPastaPai, setEnviaIdPastaPai] = useState({
    idPastaPai: "",
    tipo: "",
    nome: "",
  });
  const [atividadeRecenteSelecionada, setAtividadeRecenteSelecionada] =
    useState(false);
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  function direcionar(e) {
    // verifica se esta na raiz

    if (e.sucesso == true) {
      if (e.local == "nuvem") {
        if (e.idPasta == null) {
          listarPastasArquivosRaiz(e.page);
        } else {
          buscarPastasFilhas(e.idPasta, "pasta", e.page);
          historicoPastaRaizes(e.idPasta, e.nomePasta, true);
        }
      } else {
        listarLixeira(e.page);
      }
    } else {
      message.warn("Arquivo ou pasta não localizado.");
    }
  }

  const mostrarListagem = () => {
    if (
      visualizarListagem &&
      (showAdicionarPasta ||
        mostrarListagemFavoritos ||
        mostrarListagemLinks ||
        atividadeRecenteSelecionada)
    ) {
      return (
        <ListagemPastasArquivos
          atividadeRecenteSelecionada={atividadeRecenteSelecionada}
          setAtividadeRecenteSelecionada={setAtividadeRecenteSelecionada}
          enviaIdPastaPai={enviaIdPastaPai}
          setEnviaIdPastaPai={setEnviaIdPastaPai}
          data={dataSource}
          mudarPagina={mudarPaginaArquivoPastas}
          buscarPastasFilhas={incluirPastaSelecionada}
          showInfo={showInfo}
          favoritar={favoritar}
          showEditar={showEditar}
          showRenomear={showRenomear}
          removerItem={removerItem}
          IsAdmin={IsAdmin}
          ordenacao={ordenacao}
          setOrdenacao={setOrdenacao}
          colunaOrdenada={colunaOrdenada}
          setColunaOrdenada={setColunaOrdenada}
          // clicarColuna={clicarColuna}
          coluna={colunaPadrao}
          setColuna={setColunaPadrao}
          downloadFile={downloadFile}
          gerarLinkunico={handleGerarLinkUnico}
          handleRemoverFavorito={handleRemoverFavorito}
          mostrarListagemLinks={mostrarListagemLinks}
          handleRemoverLink={handleRemoverLink}
          showModalVisualizar={showModalVisualizar}
          atualizarPastasDragInDrop={atualizarPastasDragInDrop}
          showModalCompartilhar={showModalCompartilhar}
          showModalCopiar={showModalCopiar}
          showModalMover={showModalMover}
          mostrarListagemFavoritos={mostrarListagemFavoritos}
          handleAlterarClassificacao={handleAlterarClassificacao}
          selecionarItemParaDownload={selecionarItem}
          setItensSelecionados={setItensSelecionados}
          itemsSelecionadosMover={itensSelecionados}
          marcarTodosItens={marcarTodos}
          isSelectAll={isSelectedAll}
          treeData={treeData}
        />
      );
    } else if (mostrarListagemInativos) {
      return (
        <ListagemLixeira
          ordenacao={ordenacao}
          setOrdenacao={setOrdenacao}
          data={dataSourceLixeira}
          listagemLixeira={listarLixeira}
          aumentarItensPorPagina={aumentarPaginaLixeira}
          restaurarArquivoPasta={restaurarArquivoPasta}
          removerLixeira={removerLixeira}
          incluirPastaSelecionada={incluirPastaSelecionada}
          showModalVisualizar={showModalVisualizar}
        />
      );
    } else if (mostrarListagemItensRecentes) {
      return (
        <ListagemItensRecentes
          setOrdenacao={setOrdenacao}
          data={dataSource}
          direcionar={direcionar}
          mudarPaginaItensRecentes={handleListarAtividadeRecentes}
          incluirPastaSelecionada={incluirPastaSelecionada}
          showModalVisualizar={showModalVisualizar}
        />
      );
    } else if (visualizarGaleria) {
      return (
        <CardGaleria
          data={dataSource}
          mudarPagina={mudarPaginaArquivoPastas}
          buscarPastasFilhas={incluirPastaSelecionada}
          showInfo={showInfo}
          favoritar={favoritar}
          showEditar={showEditar}
          showRenomear={showRenomear}
          removerItem={removerItem}
          IsAdmin={IsAdmin}
          downloadFile={downloadFile}
          gerarLinkunico={handleGerarLinkUnico}
          handleRemoverFavorito={handleRemoverFavorito}
          mostrarListagemLinks={mostrarListagemLinks}
          handleRemoverLink={handleRemoverLink}
          showModalVisualizar={showModalVisualizar}
          atualizarPastasDragInDrop={atualizarPastasDragInDrop}
          showModalCompartilhar={showModalCompartilhar}
          showModalCopiar={showModalCopiar}
          showModalMover={showModalMover}
          selecionarItemParaDownload={selecionarItem}
          marcarTodosItens={marcarTodos}
          pastasCompartilhadasParaMim={pastasCompartilhadasParaMim}
          handleSairCompartilhamento={handleSairCompartilhamento}
          mostrarListagemFavoritos={mostrarListagemFavoritos}
          menuSelecionado={menuSelecionado}
          isSelectAll={isSelectedAll}
          treeData={treeData}
          setItensSelecionados={setItensSelecionados}
          itemsSelecionadosMover={itensSelecionados}
        />
      );
    } else if (
      (pastasCompartilhadasParaMim || pastasCompartilhadasPorMim) &&
      visualizarListagem
    ) {
      return (
        <ListagemPastasCompartilhadas
          data={dataSource}
          ordenacao={ordenacao}
          setOrdenacao={setOrdenacao}
          mudarPagina={mudarPaginaArquivoPastas}
          buscarPastasFilhas={incluirPastaSelecionada}
          showInfo={showInfo}
          favoritar={favoritar}
          showEditar={showEditar}
          showRenomear={showRenomear}
          removerItem={removerItem}
          IsAdmin={IsAdmin}
          downloadFile={downloadFile}
          gerarLinkunico={handleGerarLinkUnico}
          handleRemoverFavorito={handleRemoverFavorito}
          mostrarListagemLinks={mostrarListagemLinks}
          handleRemoverLink={handleRemoverLink}
          showModalVisualizar={showModalVisualizar}
          atualizarPastasDragInDrop={atualizarPastasDragInDrop}
          showModalCompartilhar={showModalCompartilhar}
          handleSairCompartilhamento={handleSairCompartilhamento}
          algumCompartilhamento={algumCompartilhamento}
          showModalCopiar={showModalCopiar}
          showModalMover={showModalMover}
        />
      );
    }
  };

  const registrarDownload = (idArquivo) => {
    trackPromise(
      registrarDownloadArquivo(idArquivo)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const registrarVisualizacao = (idArquivo) => {
    trackPromise(
      registrarVisualizacaoArquivo(idArquivo)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  // RD 94908: só entrar na pasta conta na Análise de Acessos; expandir a árvore passa contabilizar=false.
  const registrarVisualizacaoPastas = (idPasta, contabilizar = true) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta, contabilizar)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleAlterarClassificacao = (item, classificacao) => {
    if (item.tipo == 0) {
      trackPromise(
        alterarClassificacaoPasta(IdUser, item.id, classificacao)
          .then((res) => {
            if (!res.fail) {
              message.success(lang.Classificacao_alterada_com_sucesso);
              mudarPaginaArquivoPastas(paginaAtual);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      trackPromise(
        alterarClassificacaoArquivo(IdUser, item.id, classificacao)
          .then((res) => {
            if (!res.fail) {
              message.success(lang.Classificacao_alterada_com_sucesso);
              mudarPaginaArquivoPastas(paginaAtual);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const showModalPasta = () => {
    setModalAddPasta(true);
  };
  const closeModalPasta = () => {
    setModalAddPasta(false);
  };
  const showModalUpload = () => {
    setModalUpload(true);
  };
  const closeModalUpload = () => {
    setModalUpload(false);
  };
  const showModalInfo = () => {
    setModalInfo(true);
  };
  const closeModalInfo = () => {
    setModalInfo(false);
  };
  const showModalRenomear = () => {
    setModalRenomear(true);
  };
  const closeModalRenomear = () => {
    setModalRenomear(false);
    if (local === "filho") {
      pesquisarPastasArquivos(pageFilho);
    }

    if (local === "pai") {
      listarPastasArquivosRaiz(paginar, ordenacao);
    }
  };
  const showEditarPasta = () => {
    setModalEditarPasta(true);
  };
  const closeEditarPasta = () => {
    setModalEditarPasta(false);
  };
  const showEditarArquivo = () => {
    setModalEditarArquivo(true);
  };
  const closeEditarArquivo = () => {
    setModalEditarArquivo(false);
  };
  const showModalLinkUnico = () => {
    setModalLinkUnico(true);
  };
  const closeModalLinkUnico = () => {
    // listarLinksCompartilhados(1, null);
    message.success(lang.Links_atualizados_com_sucesso);
    setModalLinkUnico(false);
  };
  const showModalLinkMultiplos = () => {
    setModalLinkMultiplos(true);
  };
  const closeModalLinkMultiplos = () => {
    setModalLinkMultiplos(false);
  };
  const showModalVisualizar = (item) => {
    if (item != null) {
      registrarVisualizacao(item.id);
      setArquivoVisualizar(item);
      setModalVisualizar(true);
    }
  };
  const closeModalVisualizar = () => {
    setModalVisualizar(false);
  };
  const showModalCompartilhar = (pasta) => {
    if ((pasta && pasta.tipo == 1) || pasta.tipo == 0) {
      closeModalNovoCompartilhamento();
      setPastaACompartilhar(pasta);
      setModalCompartilhar(true);
    }
  };
  const closeModalCompartilhar = () => {
    setPastaACompartilhar(null);
    setModalCompartilhar(false);
  };
  const showModalNovoCompartilhamento = () => {
    setModalNovoCompartilhamento(true);
  };
  const closeModalNovoCompartilhamento = () => {
    setModalNovoCompartilhamento(false);
  };

  const showModalCopiar = (item) => {
    setItemSelecionadoCopiarMover(item);
    setModalCopiar(true);
  };

  const closeModalCopiar = (item) => {
    mudarPaginaArquivoPastas(paginaAtual);
    setModalCopiar(false);
  };

  const showModalMover = (item) => {
    setItemSelecionadoCopiarMover(item);
    setModalMover(true);
  };

  const closeModalMover = (item) => {
    mudarPaginaArquivoPastas(paginaAtual);
    setModalMover(false);
  };

  const handleAlterarVisualizacao = (value) => {
    if (value == "G") {
      setVisualizarListagem(false);
      setVisualizarGaleria(true);
    } else {
      setVisualizarListagem(true);
      setVisualizarGaleria(false);
    }
  };

  const closeModalMoverPastasArquivos = () => {
    setSelectedAll(false);
    setItensSelecionados([]);
    mudarPaginaArquivoPastas(paginaAtual);
    setShowModalMoverPastasArquivos(false);
  };

  const closeModalCopiarPastasArquivos = () => {
    setSelectedAll(false);
    setItensSelecionados([]);
    mudarPaginaArquivoPastas(paginaAtual);
    setShowModalCopiarPastasArquivos(false);
  };

  const showModalRemoverConfirmacao = () => {
    setModalRemoverConfirmacao(true);
  };
  const closeModalRemoverConfirmacao = () => {
    setModalRemoverConfirmacao(false);
  };

  const [banners, setBanners] = useState([]);
  const listaBanners = () => {
    trackPromise(
      getListagemBanner()
        .then((res) => {
          if (!res.fail && res.data) {
            setBanners([...res.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  useEffect(() => {
    listaBanners();
  }, []);
  return (
    <Spin spinning={loading}>
      <Header
        style={{ marginBottom: "2rem" }}
        setBuscarPorNome={setBuscarPorNome}
        mostrarPesquisar={true}
        local={local}
        setLocal={setLocal}
        showInfo={showInfo}
        buscarPorNome={buscarPorNome}
        setMostrarPesquisaAvancada={setMostrarPesquisaAvancada}
        mostrarPesquisaAvancada={mostrarPesquisaAvancada}
      />

      <div className="container overflowGaleria">
        <div className="row">
          <div className="col-md-3">
            <MenuGaleriaMidia
              setOrdenacao={setOrdenacao}
              pastaSelecionada={pastaSelecionada}
              onLoadData={onLoadData}
              pastaExpandida={pastaExpandida}
              treeData={treeData}
              listaDeFavoritos={listaDeFavoritos}
              listarLixeira={listarLixeira}
              listarLinksCompartilhados={listarLinksCompartilhados}
              showTreeData={showTreeData}
              listarPastasCompartilhadas={listarPastasCompartilhadas}
              handleListarAtividadeRecentes={handleListarAtividadeRecentes}
              menuSelecionado={menuSelecionado}
              expandedKeys={expandedKeys}
              selectedKeys={selectedKeys}
              setTreeData={setTreeData}
              setSelectedKeys={setSelectedKeys}
              // data={item}

              itensSelecionados={itensSelecionados}
              setItensSelecionados={setItensSelecionados}
              atualizarPastasDragInDrop={atualizarPastasDragInDrop}
              itemsSelecionadosMover={itensSelecionados}
            />
          </div>
          <div className="col-md-9 col-sm-12">
            <Swiper
              autoplay={100}
              navigation={true}
              pagination={true}
              keyboard={true}
              modules={[Navigation, Pagination]}
              className="mySwiper"
            >
              {banners?.map((e, i) => (
                <SwiperSlide key={i}>
                  <a href={e.link} target="_blank">
                    <img
                      width={"100%"}
                      src={e.urlArquivo}
                      style={{ borderRadius: "10px", overflow: "hidden" }}
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            {mostrarPesquisaAvancada && (
              <div className="todosDropPesquisaAvancada">
                <select className="dropPesquisaAvancada">
                  <option>Ano / Modelo</option>
                  <option>2023 / 2024</option>
                  <option>2022 / 2023</option>
                  <option>2021 / 2022</option>
                  <option>2020 / 2021</option>
                  <option>2019 / 2020</option>
                </select>
                <select className="dropPesquisaAvancada">
                  <option>Modelo</option>
                  <option>2023</option>
                  <option>2022</option>
                  <option>2021</option>
                  <option>2020</option>
                  <option>2019</option>
                </select>
                <select className="dropPesquisaAvancada">
                  <option>Tipo de arquivo</option>
                  <option>JPG</option>
                  <option>PNG</option>
                  <option>MP4</option>
                  <option>DOC</option>
                  <option>XLSX</option>
                </select>
              </div>
            )}

            {/* {!mostrarListagemPastasCompartilhadas ? (
              <div className="row">
                <hr className="linha-menus-bottom" />
              </div>
            ) : (
              <div className="row">
                <hr className="linha-menus-bottomCompartilhar" />
              </div>
            )} */}

            <div
              className={showAdicionarPasta ? "caminho-pastas ml-1" : "d-none"}
            >
              {showAdicionarPasta &&
                pastaAtual.map((item, index) => (
                  <>
                    <button
                      className="pasta-navegacao-galeria p-0 mt-5"
                      onClick={() =>
                        changeNavegacao(item.id, "pasta", item.name)
                      }
                    >
                      {index !== 0 ? (
                        <span style={{ color: "#939393", margin: "0 20px" }}>
                          {" "}
                          &gt;{" "}
                        </span>
                      ) : null}

                      <span>{item.name}</span>
                    </button>
                  </>
                ))}
            </div>
            <div className="d-flex align-items-center justify-content-between flex-wrap mt-3">
              <div style={{ maxWidth: 200, width: "100%", margin: "5px 0px" }}>
                {itensSelecionados.length > 0 ? (
                  <button
                    className="button-download-todos"
                    onClick={handleEfetuarDownload}
                  >
                    {lang.Efetuar_download}
                  </button>
                ) : null}
              </div>
              <div style={{ maxWidth: 200, width: "100%", margin: "5px 0px" }}>
                {itensSelecionados.length > 0 &&
                IsAdmin.toLocaleLowerCase() == "true" ? (
                  <button
                    className="button-download-todos"
                    onClick={CopiarDocumentos}
                  >
                    {lang.Copiar}
                  </button>
                ) : null}
              </div>
              <div style={{ maxWidth: 200, width: "100%", margin: "5px 0px" }}>
                {itensSelecionados.length > 0 &&
                IsAdmin.toLocaleLowerCase() == "true" ? (
                  <button
                    className="button-download-todos"
                    onClick={MoverDocumentos}
                  >
                    {lang.Mover}
                  </button>
                ) : null}
              </div>
              <div style={{ maxWidth: 200, width: "100%", margin: "5px 0px" }}>
                {itensSelecionados.length > 0 &&
                IsAdmin.toLocaleLowerCase() == "true" ? (
                  <button
                    className="button-download-todos"
                    onClick={RemoverDocumentos}
                  >
                    {lang.Lixeira}
                  </button>
                ) : null}
              </div>
            </div>
            <div className="div-galeria-opcoes">
              {/* {mostrarTitulo()} */}

              <div>
                {showAdicionarPasta &&
                  (IsAdmin.toLocaleLowerCase() == "true" || isMidia) && (
                    <div className="buttons-add-upload pl-0">
                      <button
                        onClick={showModalPasta}
                        style={{ color: "#828282" }}
                      >
                        <img src={addPastaSvg} /> <b>{lang.Adicionar_pasta}</b>
                      </button>
                      <button
                        onClick={showModalUpload}
                        style={{ color: "#828282" }}
                      >
                        <img src={uploadfileSvg}></img>{" "}
                        <b>{lang.Fazer_upload}</b>
                      </button>

                      {PastaAnteriorVerifica == true && (
                        <button
                          onClick={() => {
                            showModalCompartilhar(compartilharPastaAnterior);
                          }}
                        >
                          <LuFolderOpen
                            style={{ fontSize: 20, color: "#828282" }}
                          />{" "}
                          <span style={{ color: "#828282" }}>
                            {lang.Compartilhar_Pasta}
                          </span>
                        </button>
                      )}
                    </div>
                  )}
                {mostrarListagemLinks && (
                  <div className="buttons-add-upload pl-0">
                    <button onClick={showModalLinkMultiplos}>
                      <GoPlusCircle
                        style={{ color: "#828282" }}
                        fontSize={20}
                        fontWeight={"bold"}
                        className="mr-2"
                      />
                      <span style={{ color: "#828282" }}>
                        {lang.Criar_novo_link}
                      </span>
                    </button>
                  </div>
                )}
                {mostrarListagemPastasCompartilhadas &&
                  pastasCompartilhadasPorMim && (
                    <div
                      className=" buttons-add-upload pl-0 mb-3"
                      style={{ whiteSpace: "nowrap", marginLeft: "30px" }}
                    >
                      <button onClick={showModalNovoCompartilhamento}>
                        <img src={addPastaSvg} />{" "}
                        {lang.Nova_pasta_compartilhada}
                      </button>
                    </div>
                  )}
              </div>
              <div>
                {!visaoMobile &&
                  !mostrarListagemInativos &&
                  !mostrarListagemItensRecentes && (
                    <div>
                      {/* <span className="title-visualizacao ">
                        {lang.Visualizacao}:
                      </span> */}
                      <div className="d-flex align-items-center">
                        <div
                          className="button-visualizacao  ml-2"
                          onClick={() => handleAlterarVisualizacao("G")}
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={
                              visualizarGaleria
                                ? "visualizacao-selecionada"
                                : ""
                            }
                          >
                            <path
                              d="M13.353 21C13.0878 21 12.8334 20.8946 12.6459 20.7071C12.4584 20.5196 12.353 20.2652 12.353 20V13.353C12.353 13.0878 12.4584 12.8334 12.6459 12.6459C12.8334 12.4584 13.0878 12.353 13.353 12.353H20C20.2652 12.353 20.5196 12.4584 20.7071 12.6459C20.8946 12.8334 21 13.0878 21 13.353V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H13.353ZM1 21C0.734784 21 0.48043 20.8946 0.292893 20.7071C0.105357 20.5196 0 20.2652 0 20V13.353C0 13.0878 0.105357 12.8334 0.292893 12.6459C0.48043 12.4584 0.734784 12.353 1 12.353H7.647C7.91222 12.353 8.16657 12.4584 8.35411 12.6459C8.54164 12.8334 8.647 13.0878 8.647 13.353V20C8.647 20.2652 8.54164 20.5196 8.35411 20.7071C8.16657 20.8946 7.91222 21 7.647 21H1ZM13.353 8.647C13.0878 8.647 12.8334 8.54164 12.6459 8.35411C12.4584 8.16657 12.353 7.91222 12.353 7.647V1C12.353 0.734784 12.4584 0.48043 12.6459 0.292893C12.8334 0.105357 13.0878 0 13.353 0L20 0C20.2652 0 20.5196 0.105357 20.7071 0.292893C20.8946 0.48043 21 0.734784 21 1V7.647C21 7.91222 20.8946 8.16657 20.7071 8.35411C20.5196 8.54164 20.2652 8.647 20 8.647H13.353ZM1 8.647C0.734784 8.647 0.48043 8.54164 0.292893 8.35411C0.105357 8.16657 0 7.91222 0 7.647V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0L7.647 0C7.91222 0 8.16657 0.105357 8.35411 0.292893C8.54164 0.48043 8.647 0.734784 8.647 1V7.647C8.647 7.91222 8.54164 8.16657 8.35411 8.35411C8.16657 8.54164 7.91222 8.647 7.647 8.647H1Z"
                              fill="#9E9E9E"
                            />
                          </svg>
                        </div>
                        <div
                          className="button-visualizacao  ml-2"
                          onClick={() => handleAlterarVisualizacao("L")}
                        >
                          <svg
                            width="22"
                            height="21"
                            viewBox="0 0 22 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={
                              visualizarListagem
                                ? "visualizacao-selecionada"
                                : ""
                            }
                          >
                            <path
                              d="M7.471 21C7.20578 21 6.95143 20.8946 6.76389 20.7071C6.57636 20.5196 6.471 20.2652 6.471 20V16.75C6.471 16.4848 6.57636 16.2304 6.76389 16.0429C6.95143 15.8554 7.20578 15.75 7.471 15.75H21C21.2652 15.75 21.5196 15.8554 21.7071 16.0429C21.8946 16.2304 22 16.4848 22 16.75V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H7.471ZM1 21C0.734784 21 0.48043 20.8946 0.292893 20.7071C0.105357 20.5196 0 20.2652 0 20V16.75C0 16.4848 0.105357 16.2304 0.292893 16.0429C0.48043 15.8554 0.734784 15.75 1 15.75H4.176C4.44122 15.75 4.69557 15.8554 4.88311 16.0429C5.07064 16.2304 5.176 16.4848 5.176 16.75V20C5.176 20.2652 5.07064 20.5196 4.88311 20.7071C4.69557 20.8946 4.44122 21 4.176 21H1ZM7.471 13.125C7.20578 13.125 6.95143 13.0196 6.76389 12.8321C6.57636 12.6446 6.471 12.3902 6.471 12.125V8.875C6.471 8.60978 6.57636 8.35543 6.76389 8.16789C6.95143 7.98036 7.20578 7.875 7.471 7.875H21C21.2652 7.875 21.5196 7.98036 21.7071 8.16789C21.8946 8.35543 22 8.60978 22 8.875V12.125C22 12.3902 21.8946 12.6446 21.7071 12.8321C21.5196 13.0196 21.2652 13.125 21 13.125H7.471ZM1 13.125C0.734784 13.125 0.48043 13.0196 0.292893 12.8321C0.105357 12.6446 0 12.3902 0 12.125V8.875C0 8.60978 0.105357 8.35543 0.292893 8.16789C0.48043 7.98036 0.734784 7.875 1 7.875H4.176C4.44122 7.875 4.69557 7.98036 4.88311 8.16789C5.07064 8.35543 5.176 8.60978 5.176 8.875V12.125C5.176 12.3902 5.07064 12.6446 4.88311 12.8321C4.69557 13.0196 4.44122 13.125 4.176 13.125H1ZM7.471 5.25C7.20578 5.25 6.95143 5.14464 6.76389 4.95711C6.57636 4.76957 6.471 4.51522 6.471 4.25V1C6.471 0.734784 6.57636 0.48043 6.76389 0.292893C6.95143 0.105357 7.20578 0 7.471 0L21 0C21.2652 0 21.5196 0.105357 21.7071 0.292893C21.8946 0.48043 22 0.734784 22 1V4.25C22 4.51522 21.8946 4.76957 21.7071 4.95711C21.5196 5.14464 21.2652 5.25 21 5.25H7.471ZM1 5.25C0.734784 5.25 0.48043 5.14464 0.292893 4.95711C0.105357 4.76957 0 4.51522 0 4.25V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0L4.176 0C4.44122 0 4.69557 0.105357 4.88311 0.292893C5.07064 0.48043 5.176 0.734784 5.176 1V4.25C5.176 4.51522 5.07064 4.76957 4.88311 4.95711C4.69557 5.14464 4.44122 5.25 4.176 5.25H1Z"
                              fill="#9E9E9E"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}{" "}
              </div>

              {mostrarListagemInativos && (
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <label>{lang.Data_do_Descarte}</label>
                      <Input
                        className="input-data"
                        type="date"
                        onChange={(e) =>
                          setLixeiraFilter({
                            ...lixeiraFilter,
                            dataDescarte: e.target.value,
                          })
                        }
                        value={lixeiraFilter?.dataDescarte}
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <label>{lang.Mes}</label>
                      <Input
                        className="input-data"
                        type="number"
                        placeholder="1-12"
                        onChange={(e) =>
                          setLixeiraFilter({
                            ...lixeiraFilter,
                            mesDescarte: e.target.value,
                          })
                        }
                        value={lixeiraFilter?.mesDescarte}
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <label>{lang.Ano}</label>
                      <Input
                        className="input-data"
                        type="number"
                        onChange={(e) =>
                          setLixeiraFilter({
                            ...lixeiraFilter,
                            anoDescarte: e.target.value,
                          })
                        }
                        value={lixeiraFilter?.anoDescarte}
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <label>{lang.Autor}</label>
                      <Input
                        className="input-data"
                        onChange={(e) =>
                          setLixeiraFilter({
                            ...lixeiraFilter,
                            autor: e.target.value,
                          })
                        }
                        value={lixeiraFilter?.autor}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div>{mostrarListagem()}</div>
          </div>

          <Col sm={24} md={24} lg={24}>
            <Modal
              title={
                <span className="modal-title-novaPasta ">
                  {lang.Nova_pasta}
                </span>
              }
              visible={modalAddPasta}
              className="modal-novo"
              // onCancel={closeModalPasta}
              closable={false}
              destroyOnClose={false}
              footer={[]}
            >
              <CloseOutlined
                onClick={closeModalPasta}
                className="custom-close-icon"
              />
              <Row>
                <Col span={24}>
                  <Form form={form} layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                      className="label-usuario  espacoInternoNovaPasta"
                      name="nomePasta"
                    >
                      <div className="criar-pasta-input">
                        <img
                          src={infoPastaSvg}
                          style={{ width: 40, height: 40 }}
                        />
                        <Input
                          role={require}
                          placeholder={lang.Nome_da_pasta}
                          className="input-usuario ml-4"
                        />
                      </div>
                    </Form.Item>
                    {!isMidia && (
                      <div className="row  ">
                        <div className="col-md-12 col-sm-12 col-xl-12 mb-4 espacoNovaPasta">
                          <Radio.Group
                            onChange={(e) => setPastaParaMim(e.target.value)}
                            value={pastaParaMim}
                          >
                            <Radio value={true}>
                              {lang.Publicar_para_mim}
                            </Radio>
                            <Radio value={false}>
                              {lang.Publicar_para_todos}
                            </Radio>
                          </Radio.Group>
                        </div>
                      </div>
                    )}
                    <div className="container-buttons">
                      <button
                        type="button"
                        onClick={closeModalPasta}
                        className="button-modal-novo"
                        disabled={loading}
                      >
                        {lang.Cancelar}
                      </button>
                      <button
                        type="submit"
                        className="buttonConfirmar-modal-novo"
                        disabled={loading}
                      >
                        {lang.Criar}
                      </button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Modal>

            <Modal
              title={<span className="modal-title-lixeira "></span>}
              visible={modalRemoverConfirmacao}
              className="modal-novo-lixeira"
              // onCancel={closeModalRemoverConfirmacao}
              closable={false}
              destroyOnClose={false}
              footer={[]}
            >
              <CloseOutlined
                onClick={closeModalRemoverConfirmacao}
                className="custom-close-icon"
              />
              <div className="container-confirmacao-galeria">
                <img
                  src={icAtencao}
                  style={{ width: 150, height: 150, marginLeft: "46px" }}
                />
                <div className="">
                  <div className="text-certeza-lixeira">
                    {" "}
                    <span>
                      Você tem certeza de que quer mover o(s) item(s)
                      selecionado(s) para a lixeira?
                    </span>
                  </div>
                  <div className="text-aviso-lixeira">
                    <span>
                      Pastas e arquivos compartilhados não poderão ser acessados
                      por outros usuários.
                    </span>
                  </div>
                </div>
              </div>

              <div className="container-buttons">
                <button
                  type="button"
                  onClick={closeModalRemoverConfirmacao}
                  className="button-modal-novo"
                >
                  NÃO
                </button>
                <button
                  type="button"
                  onClick={removerSelecionados}
                  className="buttonConfirmar-modal-novo"
                >
                  SIM
                </button>
              </div>
            </Modal>

            <Modal
              closable={false}
              footer={[]}
              // onCancel={() => {
              //   setShowProgresso(false);
              // }}
              className="modal-novo-apagarLixeira"
              open={showProgresso}
              title="Por favor, aguarde..."
            >
              <CloseOutlined
                onClick={() => {
                  setShowProgresso(false);
                }}
                className="custom-close-icon"
              />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Spin
                  indicator={<LoadingOutlined spin style={{ fontSize: 50 }} />}
                />
              </div>
            </Modal>

            {modalUpload && (
              <ModalUpload
                closeModal={closeModalUpload}
                setCloseOpenModal={setModalUpload}
                showModal={showModalUpload}
                destino={pastaDestino}
                openModal={modalUpload}
                buscarPastasFilhas={incluirPastaSelecionada}
                setShowTreeData={setShowTreeData}
                setLoading={setLoading}
                loading={loading}
              />
            )}

            {modalInfo && (
              <ModalInfo
                id={idInfo}
                handleRemoverFavorito={handleRemoverFavorito}
                favoritar={favoritar}
                favoritarDesfavoritar={favoritarDesfavoritar}
                tipo={tipoInfo}
                closeModal={closeModalInfo}
                openModal={modalInfo}
              />
            )}

            <ModalRenomear
              id={idRenomear}
              tipo={tipoRenomear}
              closeModal={closeModalRenomear}
              openModal={modalRenomear}
              setBuscarPorNome={setBuscarPorNome}
              setShowTreeData={setShowTreeData}
              treeData={treeData}
              updateItemTable={renomearItemTable}
            />

            {modalEditarPasta && (
              <ModalEditarPasta
                id={idEditar}
                tipo={tipoEditar}
                closeModal={closeEditarPasta}
                openModal={modalEditarPasta}
                buscar={listarPastaArquivo}
                onLoadData={onLoadData}
                updateItemTable={renomearItemTable}
              />
            )}

            {modalEditarArquivo && (
              <ModalEditarArquivo
                id={idEditar}
                tipo={tipoEditar}
                closeModal={closeEditarArquivo}
                openModal={modalEditarArquivo}
                buscar={listarPastaArquivo}
                updateItemTable={renomearItemTable}
              />
            )}

            {modalLinkUnico && (
              <ModalGerarLinkUnico
                linkGerado={linkUnicoGerado}
                closeModal={closeModalLinkUnico}
                openModal={modalLinkUnico}
              />
            )}

            {modalLinkMultiplos && (
              <ModalGerarLinkMultiplos
                openModal={modalLinkMultiplos}
                closeModal={closeModalLinkMultiplos}
                IdUser={IdUser}
                handleGerarMultiplosLinks={handleGerarMultiplosLinks}
              />
            )}

            {modalVisualizar && (
              <ModalVisualizar
                openModal={modalVisualizar}
                closeModal={closeModalVisualizar}
                arquivo={arquivoVisualizar}
                handleGerarLinkUnico={handleGerarLinkUnico}
                IsAdmin={IsAdmin}
                handleRemoverFavorito={handleRemoverFavorito}
                removerItem={removerItem}
                showInfo={showInfo}
                favoritar={favoritar}
              />
            )}

            {pastaACompartilhar && modalCompartilhar && (
              <ModalCompartilharPasta
                openModal={modalCompartilhar}
                closeModal={closeModalCompartilhar}
                pasta={pastaACompartilhar}
                handleCompartilhar={handleCompartilhar}
                handleRemoverCompartilhar={handleRemoverCompartilhar}
              />
            )}

            {modalNovoCompartilhamento && (
              <ModalPastaCompartilhar
                closeModal={closeModalNovoCompartilhamento}
                openModal={modalNovoCompartilhamento}
                showModalCompartilhar={showModalCompartilhar}
              />
            )}

            {modalCopiar && itemSelecionadoCopiarMover ? (
              <ModalPastaCopiar
                openModal={modalCopiar}
                closeModal={closeModalCopiar}
                setShowTreeDataGaleria={setShowTreeData}
                itemSelecionadoCopiarMover={itemSelecionadoCopiarMover}
              />
            ) : null}

            {modalMover && itemSelecionadoCopiarMover ? (
              <ModalMoverPasta
                openModal={modalMover}
                closeModal={closeModalMover}
                setShowTreeDataGaleria={setShowTreeData}
                itemSelecionadoCopiarMover={itemSelecionadoCopiarMover}
              />
            ) : null}

            {showModalMoverPastasArquivos && itensSelecionados ? (
              <ModalMoverArquivosPastas
                openModal={showModalMoverPastasArquivos}
                closeModal={closeModalMoverPastasArquivos}
                setShowTreeDataGaleria={setShowTreeData}
                itemsSelecionadosMover={itensSelecionados}
              />
            ) : null}

            {showModalCopiarPastasArquivos && itensSelecionados ? (
              <ModalCopiarArquivosPastas
                selectedKeys={selectedKeys}
                openModal={showModalCopiarPastasArquivos}
                closeModal={closeModalCopiarPastasArquivos}
                setShowTreeDataGaleria={setShowTreeData}
                itemsSelecionadosCopiar={itensSelecionados}
              />
            ) : null}
          </Col>
        </div>
      </div>
    </Spin>
  );
};

export default PageGaleriaMidia;
